module.exports = __webpack_public_path__ + "media/Start-1.b0d37d5b.mp4";